import React from 'react';
import AddIcon from '@mui/icons-material/Add';

// если есть handlerAddButton, то добавляется кнопка "AddIcon"

const TableTitle = ({ title, containerClass = 'containerClass', className = '', handlerAddButton }) => {
  const Title = <h2 className={`${className} text-2xl sm:text-3xl text-gray-700 font-medium`}>{title}</h2>;

  return handlerAddButton ? (
    <div className={`flex px-3 items-center gap-6 pb-4 ${containerClass}`}>
      {Title}
      <button onClick={handlerAddButton} className="flex items-center justify-center bg-primary-500 hover:bg-primary-600 text-white rounded-full p-2">
        <AddIcon />
      </button>
    </div>
  ) : (
    Title
  );
};
export default TableTitle;
